import { useRef } from 'react';

import AppStore from '@assets/app-store.png';
import GooglePlay from '@assets/google-play.png';
import SignUpSuccess from '@assets/sign-up.json';
import { Button } from '@components/ui/button';
import { pages } from '@constants/pages';
import Lottie from 'react-lottie';
import { Link } from 'react-router';

export default function SignUpSuccessMedicine() {
  const lottieRef = useRef<any>(null);

  const isAndroid = window.navigator.userAgent.includes('Android');
  const isIPhone = window.navigator.userAgent.includes('iPhone');

  return (
    <main className="bg-primary flex min-h-dvh w-full p-4 sm:py-8">
      <div className="mx-auto flex max-w-2xl flex-col items-center justify-center">
        <Lottie
          height={390}
          isClickToPauseDisabled={true}
          options={{
            animationData: SignUpSuccess,
            loop: true,
            autoplay: true,
          }}
          ref={lottieRef}
          speed={0.7}
          title="Não foi possível carregar"
          width={390}
        />
        <h1 className="text-background mb-4 text-center text-lg">
          Seu cadastro foi realizado com sucesso, entre na plataforma para ter
          acesso aos conteúdos!
        </h1>

        {isAndroid && (
          <a
            href={
              'https://play.google.com/store/apps/details?id=br.com.gpmed.app'
            }
            target="_blank">
            <img alt="Google play logo" className="w-42" src={GooglePlay} />
          </a>
        )}

        {isIPhone && (
          <a
            className="w-40"
            href={'https://apps.apple.com/br/app/gpmed/id6476676703'}
            target="_blank">
            <img alt="App Store logo" src={AppStore} />
          </a>
        )}

        {!isIPhone && !isAndroid && (
          <Button asChild className="w-40 cursor-pointer" variant="secondary">
            <Link replace to={pages.auth.signIn}>
              Acessar
            </Link>
          </Button>
        )}
      </div>
    </main>
  );
}
